var _defs, _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_1",
    "data-name": "\\uADF8\\uB8F9 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "\\uB808\\uC774\\uC5B4_3",
    "data-name": "\\uB808\\uC774\\uC5B4 3",
    x: 24,
    y: 24,
    width: 20,
    height: 20,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABeUlEQVQ4jZTLQQ0AAAjEsErAFBaRgj5yEthzSaEwWHTGs5jYQR0AAAD//wIJzGFgYPgPxX8YGBjCSDAQpBakB6KfgWEOAAAA//8CCe5CEiDFUHTD/jMwMOwGAAAA//8CSXhikSBkKDbD/jAwMHgCAAAA//+CKQgnwVBchoUzMDAwAAAAAP//QsbEGIrfMAYGBgAAAAD//yLFUMKGMTAwAAAAAP//IsVQwoYxMDAAAAAA//8ixVDChjEwMAAAAAD//yLHUNyGMTAwAAAAAP//YiLVFryAgYEBAAAA//8i1XX4XcnAwAAAAAD//yLWMOIihYGBAQAAAP//ItYwkDg+OQhgYGAAAAAA//8i1jDi1DAwMAAAAAD//yJZIV61DAwMAAAAAP//AmFchQO+8MFuKAODJwAAAP//AkluJzMGMQ1lYNgOAAAA//8CSaAXsKTkAFRDGRjmAAAAAP//AgkKMTAwzISa7k2CYTAA0rMDbAYDgxAAAAD//wMAURyxdZ/xgvgAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.0b8399f4e5f2f8bc63640e8685bf8a61.svg";
export { ForwardRef as ReactComponent };